<template>
  <!-- Authors Table Card -->
  <a-card :bordered="false" class="header-solid h-full">
    <a-row :gutter="24" type="flex">
      <!-- Authors Table Column -->
      <a-col :span="24" class="mb-24">
        <a-form layout="inline" :form="dataForm" @submit="getDataList" class="ml-20">
          <a-form-item label="账户名称">
            <a-input v-model="dataForm.account_name" placeholder="账户名称" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
          </a-form-item>
          <a-form-item v-permission="['admin:account:create']">
            <a-button type="primary" @click="addOrUpdateHandle()">新增账户</a-button>
          </a-form-item>
        </a-form>

        <a-table :scroll="{ x: 1500 }" :columns="columns" :data-source="dataList" :pagination="false" rowKey="id"
          :loading="dataListLoading">
          <template slot="enable" slot-scope="text, row">
            <a-tag :color="text == 1 ? 'green' : 'red'">{{ text == 1 ? "正常可用" : "不可用" }}</a-tag>
          </template>
          <template slot="editBtn" slot-scope="text, row">
            <a-button type="link" class="btn-edit" @click="addOrUpdateHandle(row.account_id)"
              v-permission="['admin:account:update']">
              编辑
            </a-button>
            <a-button type="link" class="btn-edit" @click="deleteHandle(row.account_id)"
              v-permission="['admin:account:delete']">
              删除
            </a-button>
          </template>
        </a-table>
      </a-col>
      <!-- / Authors Table Column -->
    </a-row>

    <a-pagination class="mr-20 float-right" show-size-changer :current="page" :total="total"
      :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange" @change="pageCurrentChangeHandle" />
    <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
  </a-card>
  <!-- / Authors Table Card -->
</template>

<script>
import viewModule from "@/mixins/view-module";
import addorupdate from "./components/addorupdate.vue";
export default {
  mixins: [viewModule],
  components: {
    addorupdate,
  },
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/admin/account/page",
        deleteURL: "/admin/account/delete",
      },
      dataForm: {
        account_name: "",
        // enable: "1"
      },
      columns: [
        {
          title: "账户名称",
          dataIndex: "account_name",
          width: 200
        },
        {
          title: "账户号码",
          dataIndex: "account_number",
          width: 300
        },
        {
          title: "是否可用",
          dataIndex: "enable",
          scopedSlots: { customRender: "enable" },
          width: 100,
        },
        {
          title: "开户银行",
          dataIndex: "bank_name",
          width: 200
        },
        {
          title: "开户支行",
          dataIndex: "bank_branch",
          width: 200
        },
        {
          title: "创建时间",
          dataIndex: "create_time",
          width: 200
        },
        {
          title: "",
          scopedSlots: { customRender: "editBtn" },
          width: 200,
          fixed: "right",
        },
      ],
    };
  },
  methods: {},
};
</script>